import type { GlobalState } from '../../types';

export const CONNECTING_SELF_HEAL_DELAY_MS = 45_000;
export const MAX_CONNECTING_SELF_HEAL_ATTEMPTS = 3;

export function shouldTriggerConnectingSelfHeal({
  connectionState,
  authState,
  isBrowserOnline,
  connectingSince,
  now,
  attempts,
}: {
  connectionState: GlobalState['connectionState'];
  authState?: GlobalState['auth']['state'];
  isBrowserOnline: boolean;
  connectingSince?: number;
  now: number;
  attempts: number;
}) {
  if (!isBrowserOnline) {
    return false;
  }

  if (connectionState !== 'connectionStateConnecting') {
    return false;
  }

  if (
    authState === 'authorizationStateWaitPhoneNumber'
    || authState === 'authorizationStateWaitCode'
    || authState === 'authorizationStateWaitPassword'
    || authState === 'authorizationStateWaitRegistration'
    || authState === 'authorizationStateWaitQrCode'
  ) {
    return false;
  }

  if (!connectingSince) {
    return false;
  }

  if (attempts >= MAX_CONNECTING_SELF_HEAL_ATTEMPTS) {
    return false;
  }

  return now - connectingSince >= CONNECTING_SELF_HEAL_DELAY_MS;
}
